import React, {PureComponent as Component} from 'react';

import Field from "../../../../ui/template/Form/Field";
import Submit from "../../../../ui/template/Form/Submit";
import FormManager from "../../../../ui/template/Form/FormManager";
import Alerts from "../../../../ui/template/Alert/Alerts";
import DropZone from "../../../../ui/template/Drag/DropZone";
import {MCbrowser} from "../../../Context/browserContext";
import memberFileUploadApi from "../../../Controllers/MemberFileUploadApi";
import postInsertApi from "./Api/insertApi";
import {Edit, Image } from "react-feather";
import TextareaAutosize from "react-textarea-autosize";


class   PostInsert  extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;

        this.HtextChange = this.textChange.bind(this);

        this.HuploadDelete = this.uploadDelete.bind(this);
        this.HpostUpload = this.postUpload.bind(this);
        this.HreceivedFile = this.receivedFile.bind(this);

        this.handlePostUp = this.postUp.bind(this);
        this.state = {render:true};
        this.values = {  text:''  };

        this.form1=React.createRef();
        this.formAlerts=React.createRef();
        this.props=props;
        this.textEl=React.createRef();

        this.receivedFiles=[];
        this.dropZone=React.createRef();
    };

    textChange(e) {
        this.values.text =  e.target.value;
        return true;
    };

    uploadDelete(obj){
        if(obj.state!=="uploading") {
            this.dropZone.current.deleteItem(obj.id);
            this.receivedFileId=-1;
            this.uploadedFileId=-1;
        }
    };

    receivedFile(id){
        let obj = {};
        obj["id"] = id;
        obj["status"] = false;
        obj["uploadedId"] = 0;
        this.receivedFiles.push(obj);
    };

    async postUpload(fileData,fileId) {
        if(this.isAlive) {
            if (this.form1.current.isAlive) this.form1.current.setDisable();
            let pageAlerts = this.context.pageAlerts;
            this.dropZone.current.HchangeStateItem(fileId, "uploading");
            let res = await memberFileUploadApi(fileData, fileId, pageAlerts, this.dropZone.current.HuploadProgress);
            if(this.isAlive) {
                if (res.hasOwnProperty("id")) {
                    let id = res.id;
                    if (id > 0) {
                        this.uploadedFileId=id;
                        this.dropZone.current.HchangeStateItem(fileId,"uploaded",null,null);
                        await this.setUploadId(fileId,id);
                        await this.finishedUpload();
                    }
                }
                if (this.form1.current.isAlive) this.form1.current.setEnable();
            }
        }
    }

    setUploadId(fileId,id){
        if(this.receivedFiles.length>0){
            for (let i = 0; i < this.receivedFiles.length; i++) {
                if(this.receivedFiles[i].id===fileId){
                    this.receivedFiles[i].uploadedId=id;
                    this.receivedFiles[i].status=true;
                }
            }
        }
    }

    getUnUplodedId() {
        let receivedId=-1;
        if(this.receivedFiles.length>0){
            for (let i = 0; i < this.receivedFiles.length; i++) {
                if(this.receivedFiles[i].status===false){
                    receivedId=this.receivedFiles[i].id;
                    break;
                }
            }
        }
        return  receivedId ;
    }

    getUploadedIdes() {
        let uploadedIdes=[];
        if(this.receivedFiles.length>0){
            for (let i = 0; i < this.receivedFiles.length; i++) {
                if(this.receivedFiles[i].status===true){
                    uploadedIdes.push(this.receivedFiles[i].uploadedId);
                }
            }
        }
        return uploadedIdes;
    }

    async finishedUpload(){
        let receivedId=await this.getUnUplodedId();
        if(receivedId>0){
            await this.dropZone.current.getFileData(this.HpostUpload, receivedId);
        }else{
            let uploadedIdes=await this.getUploadedIdes();
            await this.postingUp(uploadedIdes);
        }
    }

    async postUp() {
        await this.finishedUpload();
    }

    async postingUp(filesTmpId=[]) {
        let pageAlerts = this.context.page.pageAlerts;
        let l=await postInsertApi(this.values.text,filesTmpId ,pageAlerts,this.formAlerts);
        if(l===true){
            this.textEl.current.value="";
            this.dropZone.current.deleteAll();
            let page = this.context.page;
            page.dispatcher.run("route","post","inserted");
        }
    }

    refresh() {
        let r=!this.state.render;
        this.setState({render:r});
    }

    componentDidMount() {

    }


    render() {

    return (
        <React.Fragment>
            <FormManager ref={this.form1} submit={this.handlePostUp}>
                <div className="box shadow-sm border rounded bg-white mb-3 osahan-share-post">
                    <ul className="nav nav-justified border-bottom osahan-line-tab" id="myTab" role="tablist">
                        <li className="nav-item">
                            <a className="nav-link active" id="home-tab" data-toggle="tab" href="#home"
                               role="tab" aria-controls="home" aria-selected="true">
                                <Edit className="ml-2" size={16} />
                                نوشتن مطلب جدید
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" id="profile-tab" data-toggle="tab" href="#profile"
                               role="tab" aria-controls="profile" aria-selected="false">
                                <Image className="ml-2" size={16} />
                                آپلود تصویر
                            </a>
                        </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active" id="home" role="tabpanel"
                             aria-labelledby="home-tab">
                            <div className="p-3 d-flex align-items-center w-100" href="#">
                                <div className="dropdown-list-image mr-3">
                                    <img className="rounded-circle" src="http://mdyaran.ir/membership/picture" alt="" />
                                    <div className="status-indicator bg-success" />
                                </div>
                                <div className="w-100">
                                    <Field   keyState="text">
                                        <TextareaAutosize  ref={this.textEl}   className="form-control border-0 p-0 shadow-none"
                                                           minRows={7} placeholder="متن جدید ... " onChange={this.HtextChange}  />
                                    </Field>
                                </div>
                            </div>
                        </div>
                        <div className="tab-pane fade" id="profile" role="tabpanel"  aria-labelledby="profile-tab">
                            <div className="p-3 w-100">
                                <DropZone openFileStr="بارگزاری تصاویر و فایل ها" ref={this.dropZone} deleteingItem={this.HuploadDelete}
                                          validTypes={["image/gif", "image/jpeg", "image/png", "image/bmp","image/x-icon","image/svg+xml",
                                              "video/mp4","video/webm","video/ogg","audio/vnd.wave","audio/wave","audio/wav","audio/x-wav","audio/mp3","audio/mpeg"
                                          ]}
                                          receivedFile={this.HreceivedFile} isEdit={false} isBtnDirectory={false} isMultiple={true} maxFiles={5} />
                            </div>
                        </div>
                        <div className="row mt-2 mb-2">
                            <div className="col-12  px-5 ">
                                <Alerts layout="relative" ref={this.formAlerts}/>
                            </div>
                        </div>
                    </div>
                    <div className="border-top p-3 d-flex align-items-center">
                        <div className="flex-shrink-1">
                            <Submit type="button" className="btn btn-primary btn-1 float-left mx-2">
                                ثبت مطلب
                            </Submit>
                        </div>
                    </div>
                </div>
            </FormManager>
        </React.Fragment>
    )
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

PostInsert.contextType = MCbrowser;

export default PostInsert;
